import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TApiPaginatedResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetAccrualPoliciesRequestSchema,
  TGetAccrualPoliciesResponseSchema,
} from "./getAccrualPolicies.schema";

export const getAccrualPolicies = (axios: IAxiosInstance) => {
  return async ({
    companyID,
    limit,
    start_at,
    q,
    policy_type,
    sort_direction,
    sort_by,
  }: TGetAccrualPoliciesRequestSchema) => {
    const { data } = await axios.noRetry.get<
      TApiPaginatedResponse<TGetAccrualPoliciesResponseSchema>
    >(`/accrual-policies`, {
      params: {
        companyID,
        limit,
        start_at,
        q,
        policy_type,
        sort_direction,
        sort_by,
      },
    });

    if (data.success) {
      return data;
    }

    throw new Error("Something went wrong");
  };
};
